export const SEARCH_CHANGE_PARKING_TYPE = 'search-change-parking-type';

const changeParkingType = ({ parkingType }) => ({ type: SEARCH_CHANGE_PARKING_TYPE, payload: { parkingType, searchType: 'bounds ' } });
export default changeParkingType;
